/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LogRouteImport } from './routes/log'
import { Route as ManageRouteImport } from './routes/manage'
import { Route as SpendRouteImport } from './routes/spend'
import { Route as TripRouteImport } from './routes/trip'
import { Route as ManageAccessibilityRouteImport } from './routes/manage/accessibility'
import { Route as ManageCategoriesRouteImport } from './routes/manage/categories'
import { Route as ManageDocumentsRouteImport } from './routes/manage/documents'
import { Route as ManageItineraryRouteImport } from './routes/manage/itinerary'
import { Route as ManagePeopleRouteImport } from './routes/manage/people'
import { Route as ManageUploadRouteImport } from './routes/manage/upload'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LogRoute = LogRouteImport.update({
  id: '/log',
  path: '/log',
  getParentRoute: () => rootRouteImport,
} as any)
const ManageRoute = ManageRouteImport.update({
  id: '/manage',
  path: '/manage',
  getParentRoute: () => rootRouteImport,
} as any)
const SpendRoute = SpendRouteImport.update({
  id: '/spend',
  path: '/spend',
  getParentRoute: () => rootRouteImport,
} as any)
const TripRoute = TripRouteImport.update({
  id: '/trip',
  path: '/trip',
  getParentRoute: () => rootRouteImport,
} as any)
const ManageAccessibilityRoute = ManageAccessibilityRouteImport.update({
  id: '/accessibility',
  path: '/accessibility',
  getParentRoute: () => ManageRoute,
} as any)
const ManageCategoriesRoute = ManageCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => ManageRoute,
} as any)
const ManageDocumentsRoute = ManageDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => ManageRoute,
} as any)
const ManageItineraryRoute = ManageItineraryRouteImport.update({
  id: '/itinerary',
  path: '/itinerary',
  getParentRoute: () => ManageRoute,
} as any)
const ManagePeopleRoute = ManagePeopleRouteImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => ManageRoute,
} as any)
const ManageUploadRoute = ManageUploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => ManageRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/log': typeof LogRoute
  '/manage': typeof ManageRouteWithChildren
  '/spend': typeof SpendRoute
  '/trip': typeof TripRoute
  '/manage/accessibility': typeof ManageAccessibilityRoute
  '/manage/categories': typeof ManageCategoriesRoute
  '/manage/documents': typeof ManageDocumentsRoute
  '/manage/itinerary': typeof ManageItineraryRoute
  '/manage/people': typeof ManagePeopleRoute
  '/manage/upload': typeof ManageUploadRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/log': typeof LogRoute
  '/manage': typeof ManageRouteWithChildren
  '/spend': typeof SpendRoute
  '/trip': typeof TripRoute
  '/manage/accessibility': typeof ManageAccessibilityRoute
  '/manage/categories': typeof ManageCategoriesRoute
  '/manage/documents': typeof ManageDocumentsRoute
  '/manage/itinerary': typeof ManageItineraryRoute
  '/manage/people': typeof ManagePeopleRoute
  '/manage/upload': typeof ManageUploadRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/log': typeof LogRoute
  '/manage': typeof ManageRouteWithChildren
  '/spend': typeof SpendRoute
  '/trip': typeof TripRoute
  '/manage/accessibility': typeof ManageAccessibilityRoute
  '/manage/categories': typeof ManageCategoriesRoute
  '/manage/documents': typeof ManageDocumentsRoute
  '/manage/itinerary': typeof ManageItineraryRoute
  '/manage/people': typeof ManagePeopleRoute
  '/manage/upload': typeof ManageUploadRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/log'
    | '/manage'
    | '/spend'
    | '/trip'
    | '/manage/accessibility'
    | '/manage/categories'
    | '/manage/documents'
    | '/manage/itinerary'
    | '/manage/people'
    | '/manage/upload'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/log'
    | '/manage'
    | '/spend'
    | '/trip'
    | '/manage/accessibility'
    | '/manage/categories'
    | '/manage/documents'
    | '/manage/itinerary'
    | '/manage/people'
    | '/manage/upload'
  id:
    | '__root__'
    | '/'
    | '/log'
    | '/manage'
    | '/spend'
    | '/trip'
    | '/manage/accessibility'
    | '/manage/categories'
    | '/manage/documents'
    | '/manage/itinerary'
    | '/manage/people'
    | '/manage/upload'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LogRoute: typeof LogRoute
  ManageRoute: typeof ManageRouteWithChildren
  SpendRoute: typeof SpendRoute
  TripRoute: typeof TripRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/log': {
      id: '/log'
      path: '/log'
      fullPath: '/log'
      preLoaderRoute: typeof LogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manage': {
      id: '/manage'
      path: '/manage'
      fullPath: '/manage'
      preLoaderRoute: typeof ManageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/spend': {
      id: '/spend'
      path: '/spend'
      fullPath: '/spend'
      preLoaderRoute: typeof SpendRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trip': {
      id: '/trip'
      path: '/trip'
      fullPath: '/trip'
      preLoaderRoute: typeof TripRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manage/accessibility': {
      id: '/manage/accessibility'
      path: '/accessibility'
      fullPath: '/manage/accessibility'
      preLoaderRoute: typeof ManageAccessibilityRouteImport
      parentRoute: typeof ManageRoute
    }
    '/manage/categories': {
      id: '/manage/categories'
      path: '/categories'
      fullPath: '/manage/categories'
      preLoaderRoute: typeof ManageCategoriesRouteImport
      parentRoute: typeof ManageRoute
    }
    '/manage/documents': {
      id: '/manage/documents'
      path: '/documents'
      fullPath: '/manage/documents'
      preLoaderRoute: typeof ManageDocumentsRouteImport
      parentRoute: typeof ManageRoute
    }
    '/manage/itinerary': {
      id: '/manage/itinerary'
      path: '/itinerary'
      fullPath: '/manage/itinerary'
      preLoaderRoute: typeof ManageItineraryRouteImport
      parentRoute: typeof ManageRoute
    }
    '/manage/people': {
      id: '/manage/people'
      path: '/people'
      fullPath: '/manage/people'
      preLoaderRoute: typeof ManagePeopleRouteImport
      parentRoute: typeof ManageRoute
    }
    '/manage/upload': {
      id: '/manage/upload'
      path: '/upload'
      fullPath: '/manage/upload'
      preLoaderRoute: typeof ManageUploadRouteImport
      parentRoute: typeof ManageRoute
    }
  }
}

interface ManageRouteChildren {
  ManageAccessibilityRoute: typeof ManageAccessibilityRoute
  ManageCategoriesRoute: typeof ManageCategoriesRoute
  ManageDocumentsRoute: typeof ManageDocumentsRoute
  ManageItineraryRoute: typeof ManageItineraryRoute
  ManagePeopleRoute: typeof ManagePeopleRoute
  ManageUploadRoute: typeof ManageUploadRoute
}

const ManageRouteChildren: ManageRouteChildren = {
  ManageAccessibilityRoute: ManageAccessibilityRoute,
  ManageCategoriesRoute: ManageCategoriesRoute,
  ManageDocumentsRoute: ManageDocumentsRoute,
  ManageItineraryRoute: ManageItineraryRoute,
  ManagePeopleRoute: ManagePeopleRoute,
  ManageUploadRoute: ManageUploadRoute,
}

const ManageRouteWithChildren =
  ManageRoute._addFileChildren(ManageRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LogRoute: LogRoute,
  ManageRoute: ManageRouteWithChildren,
  SpendRoute: SpendRoute,
  TripRoute: TripRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
